import { SxProps, Theme } from "@mui/material/styles";

export const primaryModalActionStyles: SxProps<Theme> = (theme) => ({
	padding: theme.spacing(1.2),
	marginTop: theme.spacing(1),
	"&:hover": {
		boxShadow: "none",
	},
});

export const outlinedSecondaryActionStyles: SxProps<Theme> = (theme) => ({
	backgroundColor: theme.palette.mode === "dark" ? "transparent" : theme.palette.common.black,
	borderColor:
		theme.palette.mode === "dark" ? theme.palette.action.active : theme.palette.common.black,
	boxShadow: "none",
	color: theme.palette.mode === "dark" ? theme.palette.text.primary : theme.palette.common.white,
	fontWeight: "normal",
	textTransform: "none",
	"&:hover": {
		backgroundColor:
			theme.palette.mode === "dark" ? theme.palette.action.hover : theme.palette.common.black,
		borderColor:
			theme.palette.mode === "dark" ? theme.palette.text.primary : theme.palette.common.black,
		boxShadow: "none",
	},
});

export const compactSecondaryModalActionStyles: SxProps<Theme> = (theme) => ({
	fontSize: "0.875rem !important",
	padding: theme.spacing(0),
	marginBottom: theme.spacing(0),
});

export const fullScreenSecondaryModalActionStyles: SxProps<Theme> = (theme) => ({
	fontSize: "0.875rem !important",
	paddingTop: theme.spacing(0.5),
	paddingBottom: theme.spacing(1),
});

export const secondaryModalActionStyles: SxProps<Theme> = (theme) => ({
	fontSize: "0.875rem !important",
	padding: theme.spacing(0),
	marginBottom: theme.spacing(1),
});
